import { render, staticRenderFns } from "./ComprasEmpresaLayout.vue?vue&type=template&id=fa79a0d4&"
import script from "./ComprasEmpresaLayout.vue?vue&type=script&lang=js&"
export * from "./ComprasEmpresaLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
